import { useState, useEffect } from 'react';
import { DesignerService } from '../../services/designer/designer-service';

interface PremiumDesigner {
  id: string;
  name: string;
  description: string;
  avatar: string;
  username: string;
}

interface UsePremiumDesignersResult {
  designers: PremiumDesigner[];
  loading: boolean;
  error: string | null;
}

export const usePremiumDesigners = (limitCount: number = 5): UsePremiumDesignersResult => {
  const [designers, setDesigners] = useState<PremiumDesigner[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDesigners = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await DesignerService.getPremiumDesigners(limitCount);
        setDesigners(data);
      } catch (err: any) {
        setError(err?.message || 'Failed to fetch premium designers');
        console.error('Error in usePremiumDesigners:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDesigners();
  }, [limitCount]);

  return { designers, loading, error };
};
